// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__r4Hp0","logo":"Socials_logo__VOaHs","link":"Socials_link__5w1GW","gradient":"Socials_gradient__iVfCh"};